import React from 'react';
import {Box, CircularProgress, Stack, Typography} from '@mui/material';
import TopicList from './TopicList';
import SummaryMetadata from './SummaryMetadata';

/**
 * Main content area for the summary panel.
 */
const SummaryContent = ({loading, error, summary, onTopicClick}) => {
    if (loading) {
        return (
            <Stack alignItems="center" py={2}>
                <CircularProgress size={24}/>
                <Typography variant="caption" color="text.secondary" mt={1}>
                    Analyzing...
                </Typography>
            </Stack>
        );
    }

    if (error) {
        return (
            <Stack py={1} px={2}>
                <Typography variant="caption" color="error">
                    {error}
                </Typography>
            </Stack>
        );
    }

    if (!summary) return null;

    return (
        <Stack spacing={2} p={2} pt={1}>
            {summary.dataSummary && (
                <Box>
                    <Typography variant="body1" color="text.primary">
                        {summary.dataSummary}
                    </Typography>
                </Box>
            )}

            <TopicList
                title="Well Covered"
                topics={summary.topicsCoveredWell}
                color="success"
                onTopicClick={onTopicClick}
            />

            <TopicList
                title="Needs More Coverage"
                topics={summary.topicsRequiringMoreCoverage}
                color="warning"
                onTopicClick={onTopicClick}
            />

            <TopicList
                title="Additional Topics"
                topics={summary.topicsNotInIcr}
                color="info"
                onTopicClick={onTopicClick}
            />

            <SummaryMetadata metadata={summary.metadata}/>
        </Stack>
    );
};

export default SummaryContent;
